<template>
  <PayDialog @close="closeOrderDialog" :money="parseFloat(item.payMoney)" :promote="item.promoteMoney" :tradeNo="tradeNo">
    <section class="vip-dialog">
      <div class="left">支付订单</div>
      <div class="right">
        <img :src="item.dialogImage" alt="" srcset="">
      </div>
    </section>
  </PayDialog>
</template>

<script>
import PayDialog from 'components/pay-dialog'
export default {
  name: 'vip-dialog',
  props: {
    item: Object,
    tradeNo: String
  },
  data() {
    return {
    }
  },
  components: {
    PayDialog
  },
  methods: {
    closeOrderDialog () {
      this.$store.dispatch('global/setVipFlag', false)
    },
    showDetail () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vip-dialog {
  display: flex;
  margin-bottom: 25px;
  .highlight {
    color: #F35456;
  }
  .left {
  }
  .right {
    flex: 1;
    margin: 0 60px;
    .order-info {
      .order-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }
    .price-info {
      color: #999999;
      font-size: 14px;
      .price-button {
        cursor: pointer;
        display: inline-block;
      }
      .price-list {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        background: #F9F9F9;
        padding: 8px 12px;
        .price-item {
          width: 40%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }

}
</style>
